import bulk from "./default"
import mediaBulk from "../../AppMedia/schemas/mediaBulk"

export default {
    "default": bulk,
    "documents": bulk,
    "media": mediaBulk
}
